var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/24(16)px/photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/24(16)px/photo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,4.5 C23.3284219,4.5 24,5.17157812 24,6 L24,6 L24,22.5 C24,23.3284219 23.3284219,24 22.5,24 L22.5,24 L6,24 C5.17157812,24 4.5,23.3284219 4.5,22.5 L4.5,22.5 L4.5,6 C4.5,5.17157812 5.17157812,4.5 6,4.5 L6,4.5 Z M22.5,6 L6,6 L6,22.5 L22.5,22.5 L22.5,6 Z M18,0 C18.8284219,0 19.5,0.671578125 19.5,1.5 L19.5,1.5 L19.5,3 L18,3 L18,1.5 L1.5,1.5 L1.5,18 L3,18 L3,19.5 L1.5,19.5 C0.671578125,19.5 0,18.8284219 0,18 L0,18 L0,1.5 C0,0.671578125 0.671578125,0 1.5,0 L1.5,0 Z M12.225,12.975 C12.5175469,12.6841875 12.9899531,12.6841875 13.2825,12.975 L13.2825,12.975 L15.75,15.4425 L16.725,14.4675 C17.0175469,14.1766875 17.4899531,14.1766875 17.7825,14.4675 L17.7825,14.4675 L20.7825,17.4675 C20.9255625,17.6093906 21.0055312,17.8028437 21.0043721,18.0043594 C21.0019219,18.4185937 20.6641875,18.7523906 20.25,18.7500128 L20.25,18.7500128 L8.25,18.7500128 C8.05729687,18.7472812 7.87307812,18.6705 7.73545312,18.5355937 C7.43967187,18.245625 7.43503125,17.7707812 7.725,17.475 L7.725,17.475 Z M18,9.75 C18.8284271,9.75 19.5,10.4215729 19.5,11.25 C19.5,12.0784271 18.8284271,12.75 18,12.75 C17.1715729,12.75 16.5,12.0784271 16.5,11.25 C16.5,10.4215729 17.1715729,9.75 18,9.75 Z",
    id: "Combined-Shape",
    fill: "#545D61"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.bee86de4.svg";
export { ForwardRef as ReactComponent };